import React, { ChangeEvent, useEffect, useState } from 'react'
import { SettingItem, SettingsCard } from '../../components/settings/SettingsCard'
import { axiosPatch } from '../../util/api'
import { setCurrentUser } from '../../actions/user'
import { Toasts } from '../../components/toaster/Toast'
import { useDispatch } from 'react-redux'
import { Input } from '../../components/inputs/Input'
import { isValidNumericInput } from '../../util/numeric_input'
import type { EntityId } from '../../types/constants'

interface MyBidAndCampaignSettingsProps {
    selectedProfile: Models.Profile
}

export const MyBidAndCampaignSettings = ({ selectedProfile }: MyBidAndCampaignSettingsProps) => {
    const dispatch = useDispatch()
    const settings = selectedProfile.settings as Models.Settings | null
    const [defaultTargetACOS, setDefaultTargetACOS] = useState<number | string | null>(null)
    const [loading, setLoading] = useState(false)
    const [pretend, setPretend] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [defaultProfile, setDefaultProfile] = useState<EntityId | null>(null)

    const set = (e: ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value
        if (isValidNumericInput(v)) {
            setDefaultTargetACOS(v)
            setDirty(true)
        }
    }

    useEffect(() => {
        if (settings) {
            setDefaultTargetACOS(settings.default_target_acos / 100.0)
            setPretend(settings.pretend)
            setDefaultProfile(settings?.default_profile ?? null)
        } else {
            setDefaultTargetACOS(0)
            setPretend(false)
            setDefaultProfile(null)
        }
        setLoading(false)
    }, [selectedProfile.profile_id, settings])

    const saveDefaultTargetACOS = () => {
        setLoading(true)
        axiosPatch(`settings/${settings?.id}/account`, {
            pretend,
            default_profile: defaultProfile,
            // @ts-ignore
            default_target_acos: Math.round(parseFloat(defaultTargetACOS * 100.0)),
        })
            .then((res) => {
                setLoading(false)
                dispatch(setCurrentUser(res.data))
                Toasts.success('Account settings saved')
                setDirty(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }

    const handleSave = () => {
        if (dirty) {
            saveDefaultTargetACOS()
        }
    }

    return (
        <SettingsCard
            title={'Bid & Campaign Settings'}
            loading={loading}
            onSave={dirty ? handleSave : null}
        >
            <SettingItem
                title="Default Target ACOS"
                description="The default Target ACOS inherited by all campaigns in this
            Ad Account. The default Target ACOS can be overridden at the campaign,
            ad group, and targeting level."
                rightComponent={
                    <Input
                        style={{ width: '100px' }}
                        value={defaultTargetACOS ?? 0}
                        onChange={set}
                        suffix="%"
                    />
                }
                bottomDivider={false}
            />
        </SettingsCard>
    )
}
